import API from '@/services/api';

export default {
  namespaced: true,
  state: {
    background: {
      type: '',
      url: '',
    },
    content: '',
  },
  mutations: {
    ['process:set'](state, { background, content }) {
      state.background = { ...background };
      state.content = content;
    },
  },
  actions: {
    async ['process:fetch']({ commit }) {
      try {
        const pageContent = await API.getProcessPageContent();
        commit('process:set', pageContent);
      } catch (err) {
        console.error(err);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/pages/process/index.js